module.exports = __webpack_public_path__ + "static/img/RS4288_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RS4288_1.png
// module id = offJ
// module chunks = 0